import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import moment from 'moment';
import DatePicker from 'react-datepicker';
import StatefulMultiSelect from "@khanacademy/react-multi-select";

export default class CustomerJobsReport extends Component {
    constructor(props) {
        super(props);
        this.state = {
            startDate:moment().toDate(),
            endDate:moment().toDate(),
            isLoading:false,
            getInvoicedReportUrl:'/api/v1/portal/portal-admin/customer-jobs-report',
            InvoicedJobsReportData:[],
            downloadReportName:'Customer Jobs Report',
            selectedCustomers:[],
            customers:[],
            url: "/api/v1/portal/customers/all/for-dropdown-menu",
        };
        this.handleStartDateChange = this.handleStartDateChange.bind(this);
        this.handleEndDateChange = this.handleEndDateChange.bind(this);
        this.handleCustomerSelection = this.handleCustomerSelection.bind(this);
    }
    componentDidMount() {
        let options = [];   
        return fetch(this.state.url, {
          method: "GET",
          mode: "cors",
          cache: "no-cache",
          credentials: "same-origin",
          headers: {
            "Authorization": 'Bearer ' + window.api_token
            , "Accept": 'application/json'
          },
        }).then((responseText) => {
          let response = responseText.json();
          response.then((response) => {
              response.map((customer)=>{
                options.push({
                    label : customer.company.short_name+'-'+customer.name,
                    value : customer.id
                });
            });
            this.setState({
              customers: options,
              isLoading: false
            });
          });
        });
      }
    handleStartDateChange(date) {
        this.setState({startDate: date})
    }
    handleEndDateChange(date) {
        this.setState({endDate: date})
    }
    handleCustomerSelection(selectedCustomers) {
        this.setState({selectedCustomers});
    }
    handleInvoicedJobsReportGeneration(e) {
        this.setState({isLoading: true});
        let url = this.state.getInvoicedReportUrl;
        return fetch(url, {
          method: "POST",
          mode: "cors",
          cache: "no-cache",
          credentials: "same-origin",
          headers: {
            "Authorization": 'Bearer ' + window.api_token
            , "Accept": 'application/json'
          },
          body: JSON.stringify({
            customer_ids: this.state.selectedCustomers,
            start_date:moment(this.state.startDate).format("YYYY-MM-DD"),
            end_date:moment(this.state.endDate).format("YYYY-MM-DD")
          }),
        }).then((responseText) => {
          let response = responseText.json();
          response.then((response) => {
            this.setState({
                InvoicedJobsReportData: response.jobs,
                isLoading: false
            })
          });
        });
    }
    download(filename, text) {
        filename = filename+' From '+moment(this.state.startDate).format("YYYY-MM-DD")+' To '+moment(this.state.endDate).format("YYYY-MM-DD")+'.csv';
        let element = document.createElement('a');
        element.setAttribute('href','data:text/plain;charset=utf-8,' + encodeURIComponent(text));
        element.setAttribute('download', filename);
        element.style.display = 'none';
        document.body.appendChild(element);
        element.click();
        document.body.removeChild(element);
      }
    render() {
        let invoicedJobs = [];
        const {selectedCustomers} = this.state;
        downloadableCsvDataInvoiced = '';
        let downloadableCsvDataInvoiced = "JOB REF,REG/VIN,CUSTOMER,FROM ADDRESS,FROM POSTCODE,TO ADDRESS,TO POSTCODE,STATUS,DRIVER COMPLETED DATE,JOB PRICE,INVOICE DATE,INVOICE NUMBER\n";
        if(this.state.InvoicedJobsReportData.length > 0){
            this.state.InvoicedJobsReportData.map((currentJob, index) => {
                let joburl = "/jobs/view/"+currentJob.id;
                invoicedJobs.push(
                        <tr key={index}>
                            <td className="job-ref-font16"><a href={joburl}>{currentJob.id}</a></td>
                            <td>{((currentJob.vehicle)&&(currentJob.vehicle.registration_number))?currentJob.vehicle.registration_number:''}</td>        
                            <td>{((currentJob.customer)&&(currentJob.customer.name))?currentJob.customer.name:''}</td>        
                            <td>{((currentJob!=null)&&(currentJob.pickup_address!=null)&&(currentJob.pickup_address.address_line_1))?currentJob.pickup_address.address_line_1:''}</td> 
                            <td>{((currentJob)&&(currentJob.pickup_address)&&(currentJob.pickup_address.postcode))?currentJob.pickup_address.postcode:''}</td>       
                            <td>{((currentJob!=null)&&(currentJob.dropoff_address!=null)&&(currentJob.dropoff_address.address_line_1))?currentJob.dropoff_address.address_line_1:''}</td> 
                            <td>{((currentJob!=null)&&(currentJob.dropoff_address!=null)&&(currentJob.dropoff_address.postcode))?currentJob.dropoff_address.postcode:''}</td> 
                            <td>{currentJob.status?currentJob.status:''}</td> 
                            <td>{((currentJob.driver_completed_at) ? moment(currentJob.driver_completed_at).format("DD/MM/YY") : "")}</td>             
                            <td>&pound;{currentJob.job_price?currentJob.job_price:''}</td>
                            <td>{ (currentJob.invoice_date) ? moment(currentJob.invoice_date).format("DD.MM.YY") : ""}</td>        
                            <td>{(currentJob.invoice_number ? currentJob.invoice_number : "")}</td>   
                        </tr>
                );
                if (currentJob != null && currentJob.pickup_address != null && currentJob.dropoff_address != null) {
                    downloadableCsvDataInvoiced += 
                    `"${currentJob.id || ''}",` +
                    `"${(currentJob.vehicle && currentJob.vehicle.registration_number) ? currentJob.vehicle.registration_number : ''}",` +
                    `"${(currentJob.customer && currentJob.customer.name) ? currentJob.customer.name : ''}",` +
                    `"${(currentJob.pickup_address && currentJob.pickup_address.address_line_1) ? currentJob.pickup_address.address_line_1 : ''}",` +
                    `"${(currentJob.pickup_address && currentJob.pickup_address.postcode) ? currentJob.pickup_address.postcode : ''}",` +
                    `"${(currentJob.dropoff_address && currentJob.dropoff_address.address_line_1) ? currentJob.dropoff_address.address_line_1 : ''}",` +
                    `"${(currentJob.dropoff_address && currentJob.dropoff_address.postcode) ? currentJob.dropoff_address.postcode : ''}",` +
                    `"${currentJob.status || ''}",` +
                    `"${currentJob.driver_completed_at ? moment(currentJob.driver_completed_at).format("DD/MM/YY") : ''}",` +
                    `"${currentJob.job_price || ''}",` +
                    `"${currentJob.invoice_date ? moment(currentJob.invoice_date).format("DD.MM.YY") : ''}",` +
                    `"${currentJob.invoice_number || ''}"\n`;
                }
            });
        }else{
            invoicedJobs.push(
                <tr key='no-records'><td colSpan="15" className='text-center'>No Records</td></tr>
            );
        }
        
        return (
            <div className="container-fluid">
                <div className="col-md-6">
                    <h2>Customer Jobs Report</h2>
                    <br/>
                </div>
                
                <div className="row">
                    <div className="col-md-1">
                        <label><h5>Select Start Date:</h5></label><br/>
                        <DatePicker todayButton={"Today"} dateFormat="dd/MM/yyyy" onChange={this.handleStartDateChange} selected={this.state.startDate}/>
                    </div>
                    <div className="col-md-1">
                        <label><h5>Select End Date:</h5></label><br/>
                        <DatePicker todayButton={"Today"} dateFormat="dd/MM/yyyy" onChange={this.handleEndDateChange} selected={this.state.endDate}/>
                    </div>
                    <div className="col-md-3 col-sm-12">
                        <label><h5>Select Customer</h5></label><br/>
                            <div>
                                <StatefulMultiSelect
                                    options={this.state.customers}
                                    selected={selectedCustomers}
                                    onSelectedChanged={this.handleCustomerSelection}
                                        overrideStrings={{
                                            selectSomeItems: "Select Customers...",
                                            allItemsAreSelected: "All Customers are Selected",
                                            selectAll: "Select All",
                                            search: "Search Customer",
                                        }}
                                    />
                            </div>
                    </div>
                    <div className="col-md-3">
                        <div className="form-group">
                            <button className="btn btn-lg btn-success invoiced-btn-margin" onClick={(e) => this.handleInvoicedJobsReportGeneration(e)}>
                                   <i className="fa fa-save"></i> Generate Customer Jobs Report
                            </button>
                        </div>
                    </div>
                    <div className="col-md-2">
                        <div className="form-group">
                            <button className="btn btn-primary btn-lg invoiced-btn-margin"
                                    onClick={(e) => {
                                    this.download(this.state.downloadReportName, downloadableCsvDataInvoiced);
                                  }}>
                                <i className="fa fa-download"></i> Download Customer Report
                            </button>
                        </div>
                    </div>
                </div>
                <div className="row">
                    <div className="col-md-3"><label className="alert alert-primary"><b>{this.state.InvoicedJobsReportData.length} jobs found..</b></label></div>             
                </div>
                <div className="row">
                    <div className="col-md-12 col-sm-12">
                        <div className="daily-delivered-report-tbl-scroll">
                            <table className="daily-delivered-report-tbl font-normal">
                                <thead className="sticky-top-without-zindex bg-light">
                                    <tr>
                                        <th>Job Ref</th>
                                        <th>Reg/VIN</th>
                                        <th>Customer</th>
                                        <th>From Address</th>
                                        <th>From Postcode</th>
                                        <th>To Address</th>
                                        <th>To Postcode</th>
                                        <th>Status</th>
                                        <th>Driver Completed Date</th>
                                        <th>Job price</th>
                                        <th>Invoice Date</th>
                                        <th>Invoice Number</th>
                                    </tr>
                                </thead>
                                <tbody>
                                {this.state.isLoading ?
                                (<tr><td colSpan="18"><span className="add-loading-text">
                                        <i className="fa fa-spinner fa-pulse"></i></span></td></tr>) :
                                    invoicedJobs
                                }
                                </tbody>
                            </table>
                        </div>
                        <br/><br/><br/>
                    </div>
                </div>
            </div>
        );
    }
}
if (document.getElementById('react-component-g4-logistics-portal-customer_jobs_report')) {
    ReactDOM.render(
        <CustomerJobsReport message_if_none = 'Nothing to report on.' />,
        document.getElementById('react-component-g4-logistics-portal-customer_jobs_report')
    );
}